import { Component } from 'react'
import { withTranslation } from 'react-i18next'
import withStyles from 'beam/dist/styles'
import { FormControl, FormLabel, FormHelperText } from 'beam/dist/Form'
import { TimePicker } from 'beam/dist/MuiPickers'
import fieldPropTypes from './FieldPropTypes'
import { get } from 'lodash'

const styles = {
  root: {
    display: 'inline-flex',
  },
}

class FormTimePickerField extends Component {
  invalidTimeMessage = 'Invalid Time Format'

  handleTimeChanged = newTime => {
    const {
      form,
      field: { name },
    } = this.props
    form.setFieldValue(name, newTime)
  }

  handleError = () => {
    const {
      form,
      field: { name },
    } = this.props

    const currentError = form.errors[name]
    const error = this.invalidTimeMessage

    if (error !== currentError) {
      form.setFieldError(name, error)
    }
  }

  render() {
    const {
      classes,
      label,
      field,
      required,
      form: { errors, touched },
      timePickerProps,
    } = this.props

    return (
      <FormControl
        required={required}
        error={!!get(touched, field.name) && !!get(errors, field.name)}
        fullWidth={true}
        className={classes.root}
      >
        {label && <FormLabel>{label}</FormLabel>}
        <TimePicker
          keyboard
          mask={[/\d/, /\d/, ':', /\d/, /\d/, ' ', /a|p/i, /m/i]}
          invalidDateMessage={this.invalidTimeMessage}
          {...field}
          onChange={this.handleTimeChanged}
          onError={this.handleError}
          {...timePickerProps}
        />
        {!!get(touched, field.name) && !!get(errors, field.name) && (
          <FormHelperText required={required} error={!!get(touched, field.name) && !!get(errors, field.name)}>
            {!!get(touched, field.name) && get(errors, field.name)}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

FormTimePickerField.propTypes = fieldPropTypes
FormTimePickerField.defaultProps = {
  label: '',
  timePickerProps: {},
}

export default withTranslation()(withStyles(styles)(FormTimePickerField))
